import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Half-width column cell shared by the member/animal search result cards. */
export const Cell = styled(Box)({
  width: 'calc(50% - 8px)',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '44px',
});

/** Field label above a card value (member/animal search result cards). */
export const PropsHeader = styled(Typography)(({ theme }) => ({
  color: (theme.vars ?? theme).palette.text.secondary,
  fontSize: '14px',
  lineHeight: '16px',
}));

/** Single-line, ellipsised card field value (member/animal search result cards). */
export const PropsValue = styled(Box)(({ theme }) => ({
  display: '-webkit-box',
  lineClamp: 1,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  wordBreak: 'break-word',
  textOverflow: 'ellipsis',
  color: (theme.vars ?? theme).palette.text.primary,
  fontSize: '16px',
  lineHeight: '20px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '18px',
  },
}));
